const CATEGORY_DESC = "Choose campaign category";
const CUSTOM_DESC = "Define your own campaign type";

export type CampaignKey =
  | "Customer Lifecycle Campaigns"
  | "Informational & Brand Content"
  | "Promotional Campaigns"
  | "Behavioral Campaigns"
  | "Custom";

export const campaigns = [
  { title: "Customer Lifecycle Campaigns", desc: CATEGORY_DESC },
  { title: "Informational & Brand Content", desc: CATEGORY_DESC },
  { title: "Promotional Campaigns", desc: CATEGORY_DESC },
  { title: "Behavioral Campaigns", desc: CATEGORY_DESC },
  { title: "Custom", desc: CUSTOM_DESC },
];

export const subCampaigns: Record<CampaignKey, { title: string; desc: string }[]> = {
  "Customer Lifecycle Campaigns": [
    { title: "Welcome Series", desc: "Introduce brand and drive first purchase." },
    { title: "Abandoned Cart Recovery", desc: "Recover lost revenue via reminders or offers." },
    { title: "Browse Abandonment", desc: "Re-engage interested customers with related products." },
    { title: "Post-Purchase Follow-Up", desc: "Upsell and collect reviews." },
    { title: "Behavioral", desc: "Prompt reorders of consumable goods." },
    { title: "Win-Back Campaigns", desc: "Reignite interest via exclusive offers." },
  ],
  "Informational & Brand Content": [
    { title: "Brand Storytelling Series", desc: "Showcase behind-the-scenes stories." },
    { title: "Style Guides / Lookbooks", desc: "Help customers style your products." },
    { title: "How-To Content", desc: "Educate customers on usage or care." },
    { title: "Newsletter or Product Digest", desc: "Share updates and new arrivals." },
  ],
  "Promotional Campaigns": [
    { title: "Flash Sale Alerts", desc: "Announce limited-time offers." },
    { title: "Seasonal/Holiday Promotions", desc: "Leverage holiday events for sales." },
    { title: "New Product Launches", desc: "Announce new arrivals." },
    { title: "Exclusive VIP Offers", desc: "Reward loyal customers." },
    { title: "Price Drop Alerts", desc: "Notify about discounts." },
  ],
  "Behavioral Campaigns": [
    { title: "Product Recommendation Emails", desc: "Upsell complementary items." },
    { title: "Birthday or Anniversary Emails", desc: "Personalized emotion-driven offers." },
    { title: "Review & UGC Requests", desc: "Collect reviews or social content." },
  ],
  Custom: [],
};

export const createTriggers = [
  // "create new campaign" is intentionally omitted: the "Create New Campaign"
  // button (and that phrase) is sent to the Ask DataTram API, which classifies
  // it via the `intent` field and drives the campaign UI from the response.
  "create me a new campaign",
  "create a new campaign",
  "create me a campaign",
  "start a new campaign",
  "make a new campaign",
  "begin a campaign",
  "create an email campaign for my new product launch",
  "i want to create an email campaign",
  "generate a marketing email for my new product",
  "help me write an email to promote my new product",
  "i want to send a newsletter to my subscribers",
  "write a welcome email for new customers",
  "generate a re-engagement email for inactive users",
  "create an email announcing a sale",
  "draft a seasonal holiday campaign email",
  "launch a new campaign",
  "أنشئ لي حملة جديدة",
  "ابدأ حملة جديدة",
  "أريد إنشاء حملة بريد إلكتروني",
  "أنشئ حملة بريد إلكتروني للترويج لمنتجي الجديد",
  "أريد إرسال نشرة بريدية للمشتركين",
  "اكتب بريد ترحيب للعملاء الجدد",
  "أنشئ بريد لإعادة استقطاب العملاء غير النشطين",
  "أنشئ بريد للإعلان عن تخفيضات",
  "اكتب حملة موسمية للعطلات",
];

export const menuItems = [
  {
    icon: "/Icons/money-bill.svg",
    text: "Return on Ad Spend",
    questions: [
      { icon: "/images/roi.png", text: "What’s my ROAS this month on Google Ads?" },
      { icon: "/images/trend.png", text: "Which platform has the highest ROAS right now?" },
    ],
  },
  {
    icon: "/Icons/thumbs-up.svg",
    text: "Engagement & Likes",
    questions: [
      { icon: "/images/love.png", text: "How many likes did my last Instagram post get?" },
      { icon: "/images/engage.png", text: "What’s my average engagement rate on paid vs organic posts?" },
    ],
  },
  {
    icon: "/Icons/funnel-dollar.svg",
    text: "Conversions",
    questions: [
      { icon: "/images/conversion.png", text: "How many conversions did we get from Google Ads last week?" },
      { icon: "/images/product.png", text: "What’s my cost per conversion on Meta Ads?" },
    ],
  },
  {
    icon: "/Icons/search.svg",
    text: "Impressions",
    questions: [
      { icon: "/images/impression.png", text: "How many impressions did my Facebook ads get this month?" },
      { icon: "/images/trend.png", text: "Which post had the most impressions in the last 7 days?" },
    ],
  },
];

export const quickActions = [
  "Return on Ad Spend",
  "Engagements & Likes",
  "Create New Campaign",
  "Conversions",
  "Impressions",
  "Create New List",
];
